import { getAllUsers } from 'API/user';
import { User, ViewModes } from 'features/account/account-management/account-management.types';
import { useUserData } from 'hooks/use-user-data';
import { useState } from 'react';
import useErrorStore from 'stores/error-store';

const useUsers = () => {
  useUserData();

  const handleOpenErrorDialog = useErrorStore((state) => state.handleOpenErrorDialog);

  const [users, setUsers] = useState<User[]>([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);

  const [page, setPage] = useState<number>(1);
  const [searchParam, setSearchParam] = useState('');

  const itemsPerPage = 10;
  let typingTimer: ReturnType<typeof setTimeout>;

  const fetchUsers = async (newPage: number = page, newSearch: string = searchParam) => {
    setLoading(true);
    const res = await getAllUsers(newPage - 1, itemsPerPage, undefined, undefined, newSearch, ViewModes.MANAGER, true);

    if (!res.error && res.data) {
      setUsers(res.data.users);
      setTotal(res.data.count);
      setPage(newPage);
    } else {
      setUsers([]);
      setTotal(0);
      setPage(1);
      handleOpenErrorDialog(res?.error, '/users/legacy', 'get');
    }
    setLoading(false);
  };

  /**
   * Search handlers
   */
  const handleSearchParamChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchParam(event.target.value);
  };

  const handleSearchUser = async () => {
    fetchUsers(1, searchParam);
  };

  const searchKeyUp = () => {
    clearTimeout(typingTimer);
    typingTimer = setTimeout(() => {
      handleSearchUser();
    }, 500);
  };

  const searchKeyDown = () => {
    clearTimeout(typingTimer);
  };

  const handleClearSearchField = () => {
    setSearchParam('');
    fetchUsers(1, '');
  };

  /**
   * Pagination handlers
   */
  const handleChangePage = (event: unknown, newPage: number) => {
    fetchUsers(newPage);
  };

  const resetUsers = () => {
    setPage(1);
    setSearchParam('');
    fetchUsers(1, '');
  };

  return {
    users,
    total,
    loading,
    itemsPerPage,
    page,
    searchParam,
    handleSearchParamChange,
    searchKeyUp,
    searchKeyDown,
    handleClearSearchField,
    handleChangePage,
    fetchUsers,
    resetUsers,
  };
};

export default useUsers;
